const setWindowLocationHref = (url?: string) => {
  if (url && url.length) {
    window.location.href = url;
  }
};

export default setWindowLocationHref;
